import React from 'react'
import RapportList from './RapportList/RaportList'
import {useAppSelector} from '../../../hooks'
import {getChoseRapport, getShowSettingRapport} from '../slice/rapports.slice'
import RapportChose from './RapportList/RapportChose'
import RapportSetting from './RapportSetting/RapportSetting'
import RapportDisplay from './RapportDisplay'
import {OlangItem} from '../../shared/Olang/user-interface/OlangItem/OlangItem'
import { PageHeader } from '../../shared/PageHeader/PageHeader'

const RapportComponent = ({clearList}) => {
  const show = useAppSelector(getChoseRapport)
  const settingShow = useAppSelector(getShowSettingRapport)

  return (
    <>
      {/* Page Header */}
      <PageHeader
        titleOlang="reports"
        backPath="/tagdashboard/index"
        info={
          <div className="flex align-items-center gap-2">
            <i className="pi pi-file text-xl text-primary"></i>
            <span className="text-lg font-semibold"><OlangItem olang='reports.management' /></span>
          </div>
        }
        className="m-3"
      />
      
      <div className='flex flex-column lg:flex-row  xl:flex-row '>
        {show ? <RapportChose /> : <RapportList />}
        {settingShow ? <RapportSetting /> : <RapportDisplay />}
      </div>
    </>
  )
}

export default RapportComponent
